import { Construction, AlertTriangle } from "lucide-react";
import { ResourceCategory, RESOURCE_CATEGORIES } from "@/components/guidelines/ResourceCategory";
import { VolunteerForm } from "@/components/guidelines/VolunteerForm";
import { RESOURCES } from "@/constants/testIds";

export function ResourcesPanel() {
  return (
    <div className="space-y-8">
      <div data-testid={RESOURCES.emergencyNote} className="bg-red-50 border border-red-200 rounded-sm p-5 flex gap-3">
        <AlertTriangle className="h-5 w-5 text-red-600 shrink-0 mt-0.5" />
        <p className="text-red-700 text-sm leading-relaxed">
          <strong>If you are in immediate danger or facing a medical emergency, call 911.</strong> BAP is not
          an emergency response service.
        </p>
      </div>

      <div data-testid={RESOURCES.comingSoonBanner} className="bg-[#EAF3F7] border border-zinc-200 rounded-sm p-6 flex gap-4">
        <Construction className="h-6 w-6 text-[#1E3A6E] shrink-0 mt-0.5" />
        <div>
          <p className="font-display font-bold text-zinc-950 mb-1">Support, right now</p>
          <p className="text-zinc-600 text-sm leading-relaxed">
            BiasBuster is building a stronger community support network over time. In the meantime, the
            resources below are independent, third-party organizations — not BAP services, and their listing
            here is not an endorsement — that may offer immediate crisis, mental health, civil rights, or
            professional support. The organizations below are real and available today; a fuller, funded
            directory of vetted local legal aid, mental health, and case-management support unlocks as
            funding grows.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        {RESOURCE_CATEGORIES.map((category) => (
          <ResourceCategory key={category.key} category={category} />
        ))}
      </div>

      <VolunteerForm />
    </div>
  );
}
